import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { useFiles } from 'client/store'
import filesSelectors from 'client/store/files/filesSelectors'
import { EntityProps } from 'client/types'
import React from 'react'
import { CommonWebsiteLogo } from 'src/shared/entities/website-logo'
import { WebsiteLogoInterface } from 'src/shared/types/entities/website-logo-interface'

export const WebsiteLogo = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: EntityProps<WebsiteLogoInterface>) => {
  const fileId = entity.logoFileId
  const mobileLogoFileId =
    entity?.mobileLogoFileId === undefined ? fileId : entity?.mobileLogoFileId

  const file = useFiles(state => filesSelectors.getFileById(state, fileId))
  const mobileFile = useFiles(state =>
    filesSelectors.getFileById(state, mobileLogoFileId),
  )
  return (
    <BaseEntityNew
      entity={entity}
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
    >
      <CommonWebsiteLogo
        {...entity}
        imageSrc={file?.path ?? ''}
        mobileImageSrc={
          mobileLogoFileId === null ? '' : (mobileFile?.path ?? '')
        }
      />
    </BaseEntityNew>
  )
}
